import Vue from 'vue'

import App from './App.vue'
import router from './router'
import axios from 'axios'

import { EventBus } from './event-bus.js'

import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import VueTour from 'vue-tour'
Vue.use(VueTour)
Vue.prototype.$VueTour = VueTour

import VueMaterial from 'vue-material'
Vue.use(VueMaterial)
 
import VueChatScroll from 'vue-chat-scroll'
import VueFilterDateFormat from 'vue-filter-date-format'

Vue.use(VueFilterDateFormat);
Vue.use(VueChatScroll);

const mainUrl = window.location
Vue.prototype.$mainUrl = mainUrl.origin
Vue.prototype.$socketUrl = "wss://" + mainUrl.host + "/entry"
if (mainUrl.host == "localhost:8000"){
  Vue.prototype.$socketUrl = "ws://" + mainUrl.host + "/entry"
}

/*
if(mainUrl.host.indexOf("8080") > -1){
  Vue.prototype.$mainUrl = "http://localhost:8000"
  Vue.prototype.$socketUrl = "ws://localhost:8000/entry"
}
*/

Vue.prototype.$mainDomain = "Wynum"
Vue.prototype.$coreUrl = "https://www.wynum.com"
if(mainUrl.host.indexOf("pienomial") > -1){
  Vue.prototype.$mainDomain = "Pienomial"
  Vue.prototype.$coreUrl = "https://www.pienomial.com"
}

Vue.config.productionTip = false
axios.defaults.baseURL = Vue.prototype.$mainUrl

//Enable these lines for lsb deployment.
//axios.defaults.baseURL = "https://web.lsbpienomial.com/"
//Vue.prototype.$socketUrl = "wss://web.lsbpienomial.com/entry"

import VueNativeSock from 'vue-native-websocket'

import GAuth from 'vue-google-oauth2'
const gauthOption = {
  clientId: '281826624008-7rlcthnl4g1tamhskf2fq1907mc5de75.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'select_account'
}
Vue.use(GAuth, gauthOption)
Vue.config.silent = true

import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)
Vue.use(BootstrapVue)

var firebaseConfig = {
  'messagingSenderId': '345604469650'
}
firebase.initializeApp(firebaseConfig)
const messaging = firebase.messaging()
messaging.usePublicVapidKey('BDPTOacc8L2EBl4iUXcKGE-Ttm0gE1xpAbpbz4fGcS-5B72lP7M5RQ-wlVmxXk2xPo-hdT6qKp_g8WckvUcU4no')
Vue.prototype.$messaging = messaging

import NProgress from 'vue-nprogress'
const options = {
  latencyThreshold: 100, // Number of ms before progressbar starts showing, default: 100,
  router: true, // Show progressbar when navigating routes, default: true
  http: true // Show progressbar when doing Vue.http, default: true
};
Vue.use(NProgress, options)
const nprogress = new NProgress()

import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    count: 0,
    socket: {
      isConnected: false,
      message: '',
      reconnectError: false,
    }
  },
  mutations: {
    SOCKET_ONOPEN (state, event)  {
      state.socket.isConnected = true
      Vue.prototype.$socket = event.currentTarget
      EventBus.$emit('socket_connected', state.socket.isConnected);
    },
    SOCKET_ONCLOSE (state, event)  {
      state.socket.isConnected = false
      Vue.prototype.$socket = null
    },
    SOCKET_ONERROR (state, event)  {
      //console.error(state, event)
    },
    // default handler called for all methods
    SOCKET_ONMESSAGE (state, message)  {
      state.message = message
      EventBus.$emit('socket_message', state.message);
    },
     // mutations for reconnect methods
    SOCKET_RECONNECT(state, count) {
      //console.info(state, count, "reconnection")
    },
    SOCKET_RECONNECT_ERROR(state) {
      state.socket.reconnectError = true;
      EventBus.$emit('socket_disconnected', state.socket.isConnected);
    },
    increment (state) {
      state.count++
    }
  }
})
store.$socket = Vue.prototype.$socket

//Vue.use(VueNativeSock, 'ws://localhost:15000/entry', { 
Vue.use(VueNativeSock, Vue.prototype.$socketUrl, { 
    format: 'json',
    reconnection: true, // (Boolean) whether to reconnect automatically (false)
    reconnectionAttempts: 5, // (Number) number of reconnection attempts before giving up (Infinity),
    reconnectionDelay: 2000, // (Number) how long to initially wait before attempting a new (1000)
    connectManually: true,
    store: store 
})

new Vue({
  el: '#app',
  router,
  store,
  nprogress,
  render: h => h(App)
}).$mount('#app')



